import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryScroll from "./components/CategoryScroll";
import CTADeclaration from "./components/CTADeclaration";
import ActionCards from "./components/ActionCards";
import BottomCTA from "./components/BottomCTA";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import ArticlesSection from "./components/ArticlesSection";
import { SITE_URL } from "@/constants/site";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy Spreadsheet Portugal e Brasil",
  "url": SITE_URL + "/",
  "description": "CSSBuy Spreadsheet atualizado com links verificados, vendedores confiáveis e guias completos em português.",
  "inLanguage": "pt",
  "potentialAction": {
    "@type": "SearchAction",
    "target": SITE_URL + "/?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "O que é CSSBuy Spreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "CSSBuy Spreadsheet é uma planilha completa e atualizada com links verificados de produtos, vendedores confiáveis e guias de compra para a plataforma CSSBuy.",
      },
    },
    {
      "@type": "Question",
      "name": "CSSBuy é seguro?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, o CSSBuy é uma plataforma segura e estabelecida no mercado de agentes de compras da China. A plataforma oferece proteção ao comprador, sistema de QC e múltiplas opções de pagamento seguras.",
      },
    },
    {
      "@type": "Question",
      "name": "Como usar CSSBuy?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Usar o CSSBuy é simples: cria a tua conta, usa os links da planilha para encontrar produtos, copia o link para o CSSBuy, escolhe opções e o agente fará a compra por ti.",
      },
    },
    {
      "@type": "Question",
      "name": "Os links são atualizados?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim! Atualizamos a nossa planilha semanalmente para garantir que todos os links estão ativos e os vendedores continuam confiáveis.",
      },
    },
    {
      "@type": "Question",
      "name": "Como comprar da China?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Comprar da China com CSSBuy: encontra o produto na planilha, copia o link, o agente compra por ti, recebes fotos de QC, escolhes o envio e recebes na tua morada.",
      },
    },
    {
      "@type": "Question",
      "name": "Quanto custa o frete?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "O custo do frete varia conforme o peso, destino e método de envio. Para Portugal, valores começam em €15-20 para pacotes pequenos. Usa a calculadora do CSSBuy para estimativa precisa.",
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryScroll />
        <CTADeclaration />
        <ActionCards />
        <ArticlesSection />
        <TestimonialSection />
        <BottomCTA />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}